<template>
  <b-button @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? tooltip : ''"><i class="fa fa-cogs"></i></b-button>
</template>

<script>

export default ({
  name: "button-settings",

  props: {
    variant: {
      type: String,
      default: 'warning'
    },
    tooltip: {
      type: String,
      default: 'Настройки'
    },
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
